import { render } from "./AdmissionDetailsSummary.vue?vue&type=template&id=167e5c34"
import script from "./AdmissionDetailsSummary.vue?vue&type=script&lang=js"
export * from "./AdmissionDetailsSummary.vue?vue&type=script&lang=js"
script.render = render

export default script